import logo from './logo.svg';
import './App.css';

function App() {
  return (
    /* <div classNameName="App">
      <header classNameName="App-header">
        <img src={logo} classNameName="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          classNameName="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div> */
    <>
    <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{background:"#fff",padding:"20px"}}>
      <div className="container">
        <a className="navbar-brand" href="#"><h5>ISC <span>PropEx</span></h5></a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active ">
              <a className="nav-link border-left-none" href="#">Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">About ISC PropEx</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">Exchange Property</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">Contact</a>
            </li>
            
          </ul>
        </div>
        </div>
    </nav>
</>
  );
}

export default App;
